import { createTheme } from '@material-ui/core/styles'

const theme = createTheme({
  palette: {
    type: 'light',
    primary: {
      main: '#6A148E',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#C198ED',
      contrastText: '#FFFFFF',
    },
    default: {
      main: '#F5F5F5',
      contrastText: '#464646',
    },
    purple: {
      // I guess that will be the softest color inside purple gradient
      50: '#F6F5FB',
      100: '#6A148E',
    },
    grey: {
      50: '#F5F5F5',
      100: '#F5F5F5',
      200: '#D9D9D9',
      300: '#D9D9D9',
      400: '#BCBCBC',
      500: '#BCBCBC',
      600: '#666666',
      700: '#666666',
      800: '#464646',
      900: '#464646',
      A100: '#D9D9D9',
      A200: '#BCBCBC',
      A400: '#666666',
      A700: '#464646',
    },
    error: {
      // TO DO
      main: '#EB0043',
      secondary: '#430301',
      light: '#fde0e8',
    },
    warning: {
      // TO DO
      main: '#FCE300',
      secondary: '#645301',
      light: '#fff9e0',
    },
    success: {
      // TO DO
      main: '#008330',
      secondary: '#003301',
      light: '#e0f0e6',
    },
    info: {
      // TO DO
      main: '#5B73BA',
      secondary: '#000E34',
      light: '#ebeef7',
    },
    background: {
      default: '#fff',
      paper: '#F5F5F5',
    },
    text: {
      primary: '#464646',
      secondary: '#666666',
      disabled: '#BCBCBC',
      hint: '#464646',
    },
    divider: '#BCBCBC',
  },
  typography: {
    fontFamily: "'Barlow', sans-serif",
    fontSize: 14,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 700,
    h1: {
      fontWeight: 500,
      fontSize: '1.9rem',
    },
    h2: {
      fontWeight: 400,
      fontSize: '1.6rem',
    },
    h3: {
      fontWeight: 500,
      fontSize: '1.45rem',
    },
    h4: {
      fontWeight: 400,
      fontSize: '1.18rem',
    },
    h5: {
      fontWeight: 400,
      fontSize: '1rem',
    },
    h6: {
      fontWeight: 400,
      fontSize: '0.88rem',
    },
  },
  shape: {
    borderRadius: 4,
    borderRadiusRounded: 35,
  },
})
export default theme
